import React from 'react';
import Copyright from 'common/Copyright';
import { LoginButton } from './Auth';
import { useLocation } from 'react-router';
import logo from '../assets/ezcloudllc-logo-2.png';
import './SignIn.css';
import { Redirect, useHistory } from 'react-router-dom';
import { useAuth } from 'common/auth';

export default function SignIn() {
  let auth = useAuth();
  const history = useHistory();

  let location = useLocation();
  let { from } = location.state || { from: { pathname: '/' } };
  const login = resp => auth.signIn(resp, () => history.replace(from));

  if (auth.user) {
    return <Redirect to="/settings" />;
  }

  return (
      <div className="signin-container">
        <div className="signin-content">
          <div className="signin-header">
            <a href="https://responder.services.ezcloudllc.com">
              <img src={logo} alt="Auto Responder" className="signin-logo" />
            </a>
            <h2 className="">Welcome to Auto Responder</h2>
            <p className="signin-text">Smart auto-responder for your Gmail</p>
          </div>
          <main className="public-main">
          </main>

          <div className="signin-auth">
            <p className="signin-text-2">To get started, sign in with your Google account</p>
            <LoginButton onSuccess={login} />
          </div>

          <div className="signin-privacy">
            <p>
              <Copyright />
            </p>
          </div>
        </div>
      </div>
  );
}